import { useCallback, useContext, useMemo } from 'react'
import SegmentedControl from 'ui/src/components/controls/segmented-control'
import { fitDimensions } from 'utils'
import { UGEContext } from '../../../context'
import { ugeCropTypes } from '../../../types'
import { aspectRatioFromCropType, labelFromCropType } from '../../../utilities/crop-type'
import { Subheading } from '../../style'

type Props = {
    className?: string
}

const UGECropEditorAspectRatio = ({ className }: Props) => {
    const { crop, cropType, dimensions, setCrop, setCropType } = useContext(UGEContext)

    const filteredCropOptions = useMemo(
        () =>
            ugeCropTypes.filter((option) => {
                const sourceAspectRatio = dimensions.width / dimensions.height

                if (option !== 'original') {
                    return aspectRatioFromCropType(option) !== sourceAspectRatio
                } else {
                    return true
                }
            }),

        [dimensions]
    )

    const onCropChange = useCallback(
        (index: number) => {
            const { height, width } = dimensions
            const type = filteredCropOptions[index]

            if (type !== cropType) {
                const ratio = aspectRatioFromCropType(type, dimensions.width / dimensions.height)

                setCropType(type)

                if (ratio) {
                    const newCrop = fitDimensions(
                        {
                            height: Math.round(width / ratio),
                            width,
                        },
                        {
                            height,
                            width,
                        }
                    )

                    setCrop(newCrop)
                } else {
                    setCrop({ height, width, x: 0, y: 0 })
                }
            }
        },
        [dimensions, crop, filteredCropOptions]
    )

    return (
        <div className={className}>
            <Subheading>Aspect Ratio</Subheading>
            <SegmentedControl
                index={filteredCropOptions.indexOf(cropType)}
                options={filteredCropOptions.map(labelFromCropType)}
                onChange={onCropChange}
            />
        </div>
    )
}

export default UGECropEditorAspectRatio

// const onCropChange = useCallback(
//     (index: number) => {
//         const { height, width } = board
//         const type = filteredCropOptions[index]

//         if (type !== cropType) {
//             const ratio = cropAspectRatio(type, board.aspectRatio)

//             setCropType(type)

//             if (ratio) {
//                 setCrop(fitDimensions({ width, height: Math.round(width / ratio) }, { height, width }))
//             } else {
//                 setCrop({ height, width, x: 0, y: 0 })
//             }
//         }
//     },
//     [board, crop, filteredCropOptions]
// )
